<template>
    
    <div>
        <div v-if="is_super_admin">
        <div style="padding: 0px 16px;">
            <el-button plain type="primary" @click="addVipPrivilege" size="small" icon="el-icon-plus">新增会员等级特权</el-button>
        </div>

        <div style="padding: 10px 16px;">
            <el-table
                :data="vipPrivilegeList"
                style="width: 100%;border-color:'#606266'"
                :default-sort = "{prop: 'date', order: 'descending'}"
                :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                :cell-style="{color: '#666',fontSize:'14px'}"
                border
            >
                <el-table-column
                    fixed
                    align="center"
                    prop="vip_level"
                    label="会员等级"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="min_recharge_money"
                    label="最低充值金额"
                    
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="vip_discount_amount"
                    label="折扣(1表示无折扣)"
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="is_tea_free"
                    label="免费茶水"
                    >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.is_tea_free == 1">是</el-tag>
                        <el-tag v-else>否</el-tag>
                    </template>

                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="is_enjoy_delay"
                    label="延时服务"
                    >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.is_enjoy_delay == 1">是</el-tag>
                        <el-tag v-else>否</el-tag>
                    </template>
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="delay_minutes"
                    label="延时时长"
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="is_order_first"
                    label="优先预定权"
                    >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.is_order_first == 1">是</el-tag>
                        <el-tag v-else>否</el-tag>
                    </template>
                </el-table-column>

                <el-table-column
                    align="center"
                    label="操作"
                    width="200px"
                >
                    <template slot-scope="scope">
                        <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFunc(scope.row)">删除</el-button>
                        <el-button round plain icon="el-icon-delete" type="success" size="small" @click="editFunc(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>

             </el-table>
        </div>

        <el-dialog :visible.sync="bShowDialog" :fullscreen="bShowFullscreen" :before-close="this.$dialog_close" :show-close="false">
            <div slot="title" class="dialog-title">
                <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ sDialogNmae }}</span>
                <el-button icon="el-icon-close" class='dialog-title-button' @click="bShowDialog = false"></el-button>
                <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="bShowFullscreen = !bShowFullscreen"></el-button>
            </div>

            <el-form :model="dFromData" ref="dFromData" labeel-width="100px" @class="demo-dFromData">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="会员等级" prop="vip_level">
                            <el-input-number v-model="dFromData.vip_level" :min="0" :max="20" label="会员等级" :disabled=true></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="最低充值金额" prop="min_recharge_money">
                            <el-input-number v-model="dFromData.min_recharge_money" :min="0" label="最低充值金额" ></el-input-number>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="折扣信息" prop="vip_discount_amount">
                            <el-input-number v-model="dFromData.vip_discount_amount" :min="0" :max="1" :precision="2" :step="0.1" label="最低充值金额" ></el-input-number>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="延时服务" prop="is_enjoy_delay">
                            <el-switch v-model="dFromData.is_enjoy_delay" :change="isEnjoyDelayChange()"></el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="延时时长设置" prop="delay_minutes">
                            <el-input-number v-model="dFromData.delay_minutes" :min="0" :max="60" label="延时时长" :disabled="disabledDelayMinutes"></el-input-number>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="优先预定" prop="is_order_first">
                            <el-switch v-model="dFromData.is_order_first"></el-switch>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="免费茶水" prop="is_tea_free">
                            <el-switch v-model="dFromData.is_tea_free"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>


            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="defineFunc">取 消</el-button>
                <el-button type="primary" @click="cancelFunc">确 定</el-button>
            </div>
        </el-dialog>

        </div>

        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VipPrivilegeSystem",
    data(){
        return {
            iCurrentPage: 1,
            iMaxTotal: 10,
            bShowDialog: false,
            bShowFullscreen: false,
            sDialogNmae: '新增特权',
            disabledDelayMinutes: true,
            vipPrivilegeList: [],
            dFromData: {},
            // 请求类型
            bRequestType: true,
            is_super_admin: false,
        }
    },

    mounted(){
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
        this.is_super_admin = true
        }
        this.getVipPrivilegeList()
    },

    methods: {
        // 获取特权列表
        async getVipPrivilegeList(){

            const res = await this.$axios.get('/api/vip_privilege/');
            console.log(res)
            console.log(222222222222)
            this.vipPrivilegeList = res.data;
            // this.iMaxTotal = res.data.count;
        },

        // 新增会员特权
        addVipPrivilege(){
            this.bShowDialog = true;
            this.bShowFullscreen = false;
            this.sDialogNmae = '新增特权';
            this.bRequestType = true;

            this.dFromData = {
                delay_minutes: 0,
                vip_level: 0,
                min_recharge_money: 0,
            }
            // 获取最大会员等级
            this.getMaxVipLevel();
        },

        // 获取最大会员等级
        async getMaxVipLevel(){
            // let iVipLevel = 0;
            for (let i = 0; i < this.vipPrivilegeList.length; i++) {
                if (this.vipPrivilegeList[i].vip_level >= this.dFromData.vip_level) {
                    this.dFromData.vip_level = this.vipPrivilegeList[i].vip_level + 1
                }
            }
            // return iVipLevel;
        },

        // 确定
        async cancelFunc(){
            if (!this.dFromData.is_enjoy_delay){
                this.dFromData.delay_minutes = 0;
            }

            if (this.bRequestType){
                const res = await this.$axios.post('/api/vip_privilege/', this.dFromData);
                this.requestWaring(res)
                this.getVipPrivilegeList();
            }else{
                const res = await this.$axios.put('/api/vip_privilege/' + this.dFromData.vip_privilege_id + '/', this.dFromData);
                this.requestWaring(res)
                this.getVipPrivilegeList();
            }
        },

        // 请求警告
        requestWaring(res){
            console.log(res)

            if (res.status === 201 || res.status === 200){
                this.$message({
                    message: '操作成功',
                    type: 'success'
            })
            this.bShowDialog = false
            this.getVipPrivilegeList()
            
            } else {
                this.$message({
                    message: '操作失败',
                    type: 'error'
                })
            }
        },

        // 取消
        defineFunc(){
            this.bShowDialog = false
        },

        // 是否延时变更事件
        isEnjoyDelayChange(){
            if(this.dFromData.is_enjoy_delay){
                this.disabledDelayMinutes = false
            }else{
                this.disabledDelayMinutes = true
            }
        },

        // 删除事件
        deleteFunc(row){
            var _this = this
            this.$confirm('此操作将永久删除该消息', '删除消息警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                _this.$axios.delete('/api/vip_privilege/' + row.vip_privilege_id + '/').then(
                function(res){_this.$message({type: 'success', message: '删除成功!'});
                _this.getVipPrivilegeList()})
            }).catch(() => {
                _this.$message({type: 'info',message: '已取消删除'});          
            });
        },

        // 编辑事件
        editFunc(row){
            this.bShowDialog = true;
            this.bShowFullscreen = false;
            this.sDialogNmae = '编辑特权';
            this.dFromData = row;
            this.bRequestType = false;
        },

    }

}

</script>

<style>

</style>